import {APP_HOST_URL, APP_URL, getRnd} from 'lib/utils/urlUtils';
import safeUrlAssembler from 'safe-url-assembler';
import {callAsyncBackend} from './call-authorized-backend';
import {downloadBase64} from "./utils/reportUtils";

function assembleUrl(vin, wans) {

    return safeUrlAssembler(APP_HOST_URL)
            .template('/pages/selectedResult')
            .param('vin', vin)
        + createWanQueryParams(wans);
}

function createWanQueryParams(wans) {
    return wans && Array.isArray(wans) && wans.length ? wans.map(wan => '&wan=' + wan)
        .join('') : '&wan=';
}

export const vinSearchFilterByWanUrl = async (vin, wans) => {
    const subscriptions = ['ahiAbroad', 'ahiLocal', 'ahiUsa', 'aon'];

    const url = safeUrlAssembler(APP_URL)
            .template('/service/che_data_service/rest/historyByWan')
            .param('vin', vin)
            .param('engine_cc', '')
            .param('firstRegistrationDate', '')
            .param('rnd', getRnd())
        + '&subscriptions=' + subscriptions.join(',')
        + createWanQueryParams(wans);

    const callBackend = async () => {
        const token = window.localStorage.getItem('token');
        return await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'content-type': 'application/json',
                'Token': token,
            },
        });
    };

    const handleAsyncSuccessfulResponse = async (response) => {
        return await response.json();
    };

    const handleAsyncErrorResponse = (response) => {
        if (response?.message === 'Forbidden' || response?.error === 'Forbidden') {
            return {error: true, orderLimitError: true};
        }
        return {error: true};
    };

    return callAsyncBackend(callBackend, handleAsyncSuccessfulResponse, handleAsyncErrorResponse);
}

const preparePdfReportRequest = (claimData) => {
    const vin = claimData.vin;
    const year = claimData.year;
    const engineDisplacement = claimData.engineDisplacement;

    return {
        params: {
            vin: vin,
            carManufacturer: claimData.reportData.carManufacturer,
            carModel: claimData.reportData.carModel,
            registrationYear: '' + year,
            engineCC: '' + engineDisplacement,
            footerUrl: assembleUrl(claimData.vin,
                (claimData.reportData.resultList || []).map(result => result.wan)),
        },
        body: {
            records: claimData.records,
        },
        vh: claimData.reportData.vh,
    };
};

export const downloadPDF = async (claimData) => {
    const callBackend = async () => {
        claimData.setLoader(true);

        const token = window.localStorage.getItem('token');
        return await fetch(APP_URL + '/service/pdf/rest/generate/base64/jasper/history-report', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'content-type': 'application/json',
                'Token': token,
            },
            body: JSON.stringify(preparePdfReportRequest(claimData)),
        });
    };

    const handleAsyncSuccessfulResponse = async (response) => {
        const pdfResponse = await response.json();
        if (!pdfResponse.base64) {
            return null;
        }
        downloadBase64({
            base64: pdfResponse.base64,
            fileName: 'history-report.pdf',
            dataType: 'application/octet-stream',
        })

        return pdfResponse;
    };

    try {
        return await callAsyncBackend(callBackend, handleAsyncSuccessfulResponse, () => {
            return undefined;
        });
    } finally {
        claimData.setLoader(false);
    }
};

export const aonRequest = async (aonClaimData) => {
    const callBackend = async () => {
        const token = window.localStorage.getItem('token');
        return await fetch(APP_URL + '/service/fcg_wl/rest/checkVD?id=' + aonClaimData.wan + '&vin=' + aonClaimData.vin.substring(12), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'content-type': 'application/json',
                'Token': token,
            },
        });
    };

    const handleAsyncSuccessfulResponse = async (response) => {
        return await response.json();
    };

    const handleAsyncErrorResponse = () => {
        return {error: true};
    };

    return callAsyncBackend(callBackend, handleAsyncSuccessfulResponse, handleAsyncErrorResponse);

};

export const downloadThumbnails = async (thumbnailsRequestData) => {
    const callBackend = async () => {
        const token = window.localStorage.getItem('token');
        return await fetch(APP_URL + '/service/fcg_wl/rest/dataGetThumbnail?id=' + thumbnailsRequestData.wan + '&vin=' + thumbnailsRequestData.vin.substring(12), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'content-type': 'application/json',
                'Token': token,
            },
        });
    };

    const handleAsyncSuccessfulResponse = async (response) => {
        return await response.json();
    };

    const handleAsyncErrorResponse = () => {
        return {error: true};
    };

    return callAsyncBackend(callBackend, handleAsyncSuccessfulResponse, handleAsyncErrorResponse);

};

export const setThumbnailsToState = (thumbnailsRequestData, thumbnails) => {
    if (thumbnails !== undefined) {
        thumbnailsRequestData.setThumbnails(Array.from(thumbnails));
    }
};

export const pullBigPicture = async (request) => {
    const callBackend = async () => {
        const token = window.localStorage.getItem('token');
        return await fetch(APP_URL + '/service/fcg_wl/rest/dataGetBigPhoto?id=' + request.id + '&vin=' + request.vin?.substring(12) + '&file=' + request.file, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'content-type': 'application/json',
                'Token': token,
            },
        });
    }

    const handleAsyncSuccessfulResponse = async (response) => {
        return await response.json();
    };

    const handleAsyncErrorResponse = () => {
        return {};
    };

    return callAsyncBackend(callBackend, handleAsyncSuccessfulResponse, handleAsyncErrorResponse);
};

export const detailedDescriptionCall = async (detailedDescriptionData) => {
    const callBackend = async () => {
        detailedDescriptionData.setDescriptionButtonLoading(true);
        const token = window.localStorage.getItem('token');
        return await fetch(APP_URL + '/service/fcg_wl/rest/dataGetDP?id=' + detailedDescriptionData.id + '&vin=' + detailedDescriptionData.vin
            + '&vendorId=' + detailedDescriptionData.vendorId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'content-type': 'application/json',
                'Token': token,
            },
        });
    };

    const handleAsyncSuccessfulResponse = async (response) => {
        return await response.json();
    };

    const handleAsyncErrorResponse = () => {
        return {};
    };

    return callAsyncBackend(callBackend, handleAsyncSuccessfulResponse, handleAsyncErrorResponse);

};

export const photosZipCall = async (setDownloadPhotosButtonLoading, id, vin) => {

    const callBackend = async () => {
        setDownloadPhotosButtonLoading(true);
        const token = window.localStorage.getItem('token');
        return await fetch(APP_URL + '/service/fcg_wl/rest/dataGetZipP?id=' + id + '&vin=' + vin, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'content-type': 'application/json',
                'Token': token,
            },
        });
    };

    const handleAsyncSuccessfulResponse = async (response) => {
        return await response.json();
    };

    const handleAsyncErrorResponse = () => {
        return undefined;
    };

    return callAsyncBackend(callBackend, handleAsyncSuccessfulResponse, handleAsyncErrorResponse);

};
